"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var useConfig_1 = __importDefault(require("../../_util/useConfig"));
function ScenarioBase(props) {
    var className = props.className, backgroundUrl = props.backgroundUrl, title = props.title, describe = props.describe;
    var classPrefix = (0, useConfig_1.default)().classPrefix;
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)("".concat(classPrefix, "-scene"), className) },
        react_1.default.createElement("div", { className: "scene-img", style: { backgroundImage: "url(".concat(backgroundUrl, ")") } }),
        react_1.default.createElement("div", { className: "scene-title" }, title),
        react_1.default.createElement("p", { className: "scene-desc" }, describe)));
}
exports.default = ScenarioBase;
//# sourceMappingURL=ScenarioBase.js.map